"use client";

// packages/eden-table/src/components/Col.jsx
import { useContext } from "react";
import ColumnHidingContext from './ColumnHiding/Context.js';
import { jsx } from "react/jsx-runtime";
var Col = ({ id, noSorting, ...props }) => {
  noSorting;
  const { hiddenColumns } = useContext(ColumnHidingContext);
  return /* @__PURE__ */ jsx("col", { hidden: hiddenColumns.includes(id), ...props, id });
};
Col.displayName = "Col";
var Col_default = Col;
export {
  Col_default as default
};
